import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
import TradeTitle from '@/materials/atoms/TradeTitle.vue';
import BalancesHeader from '@/components/organisms/main/trade/balances/BalancesHeader.vue';
import BalancesList from '@/components/organisms/main/trade/balances/BalancesList.vue';
import BalancesCheck from '@/components/organisms/main/trade/balances/BalancesCheck.vue';
import { balancesSubscriber, useBalances } from '@/logics/balances';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useStore } from '@/store/store';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean },
        userInfo: null
    },
    setup(__props) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const { setBalances } = useBalances();
            const store = useStore();
            const { format, BALANCES_TITLES } = useMessage();
            if (props.isAuth) {
                (([__temp, __restore] = _withAsyncContext(() => setBalances().catch(() => {
                    console.error('balances fetch error');
                }))),
                    yield __temp,
                    __restore());
            }
            const { subscribe, unsubscribe } = balancesSubscriber((_a = props.userInfo) === null || _a === void 0 ? void 0 : _a.id);
            onMounted(subscribe);
            onUnmounted(unsubscribe);
            watch(() => store.state.orderCount, setBalances);
            const isShowZero = ref(false);
            const changed = () => {
                isShowZero.value = !isShowZero.value;
            };
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", null, [
                    (!_unref(store).state.isSmartPhone)
                        ? (_openBlock(), _createBlock(TradeTitle, {
                            key: 0,
                            title: _unref(store).state.isSmartPhone ? '' : String(_unref(format)(_unref(BALANCES_TITLES).TITLE))
                        }, null, 8, ["title"]))
                        : _createCommentVNode("", true),
                    _createVNode(BalancesCheck, {
                        id: 1,
                        onChange: changed
                    }),
                    _createVNode(BalancesHeader),
                    _createVNode(BalancesList, {
                        isShowZero: isShowZero.value,
                        list: _unref(store).state.balances
                    }, null, 8, ["isShowZero", "list"])
                ]));
            };
        });
    }
});
